import Sidebar from './SideBar.vue'

const SidebarStore = {
  showSidebar: false,
  sidebarLinksOriginal: [
    {
      name: 'Dashboard',
      icon: 'now-ui-icons design_app',
      path: '/overview'
    },
    {
      name: 'User Profile',
      icon: 'now-ui-icons users_single-02',
      path: '/user'
    },
    {
      name: 'User Management',
      icon: 'now-ui-icons text_align-center',
      path: '/usermanagement'
    },
    {
      name: 'User Reports',
      icon: 'now-ui-icons files_single-copy-04',
      path: '/reports'
    },
    // {
    //   name: 'Typography',
    //   icon: 'now-ui-icons files_paper',
    //   path: '/typography'
    // },
    // {
    //   name: 'Icons',
    //   icon: 'now-ui-icons objects_diamond',
    //   path: '/icons'
    // },
    // {
    //   name: 'Maps',
    //   icon: 'now-ui-icons location_pin',
    //   path: '/maps'
    // },
    {
      name: 'Performance',
      icon: 'now-ui-icons business_chart-bar-32', // Updated icon
      path: '/performance'
    },
    {
      name: 'Leave Management',
      icon: 'now-ui-icons ui-1_calendar-60',
      path: '/leave'
    },
    {
      name: 'Payroll Management',
      icon: 'now-ui-icons business_money-coins',
      path: '/payroll'
    },
    {
      name: 'Settings',
      icon: 'now-ui-icons loader_gear',
      path: '/settings'
    },
    {
      name: 'Complains',
      icon: 'now-ui-icons ui-1_bell-53',
      path: '/complains'
    },
    {
      name: 'Policies',
      icon: 'now-ui-icons files_paper',
      path: '/policies'
    },
    {
      name: 'Reported Bugs',
      icon: 'fas fa-bug',
      path: '/reported-bugs'
    },
    {
      name: 'Activity Logs',
      icon: 'fas fa-user-shield',
      path: '/activity-logs'
    },
    {
      name: 'Chatbot Management',
      icon: 'fas fa-robot',
      path: '/chatbot'
    },
  ],
  sidebarLinks: [], 
  displaySidebar (value) {
    // we simulate the window Resize so the charts will get updated in realtime.
    const simulateWindowResize = setInterval(() => {
      window.dispatchEvent(new Event('resize'))
    }, 180)

    // we stop the simulation of Window Resize after the animations are completed
    setTimeout(() => {
      clearInterval(simulateWindowResize)
    }, 1000)

    if(value){
      document.body.classList.add('nav-open')
    } else{
      document.body.classList.remove('nav-open')
    }
    this.showSidebar = value
  }
}

const SidebarPlugin = {

  install (Vue, { store }) {
    Vue.mixin({
      computed: {
        filteredSidebarLinks() {
          const user = store.state.auth.user;
          const isAdmin = user && user.role === "admin";

          const links = [...SidebarStore.sidebarLinksOriginal];
          const adminOnlyPages = ["Chatbot Management", "Activity Logs", "Reported Bugs"];

          if (!isAdmin) {
            return links.filter(link => !adminOnlyPages.includes(link.name));
          }
          return links;
        }
      },
      watch: {
        'filteredSidebarLinks': {
          immediate: true,
          handler(newLinks) {
            SidebarStore.sidebarLinks = newLinks
          }
        }
      },
      data () {
        return {
          sidebarStore: SidebarStore
        }
      }
    })

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get () {
        return this.$root.sidebarStore
      }
    })
    Vue.component('side-bar', Sidebar)
  }
}

export default SidebarPlugin



// WEBPACK FOOTER //
// ./src/components/UIComponents/SidebarPlugin/index.js